import '../../styles/InteractiveComponents.css';

import { Box, FormControlLabel, IconButton, Radio } from '@mui/material';
import React, { useState } from 'react';

import AssetLibrary from '../../../shared/components/AssetLibrary/AssetLibrary';
import AssetService from '../../../shared/services/AssetService';
import Grid from '@mui/material/Unstable_Grid2';
import ImageIcon from '@mui/icons-material/Image';
import { InlineQuillEdit } from '../InlineQuillEdit';
import { SliderItem } from '../../models/LessonComponentContent';
import { cloneDeep } from 'lodash';
import { styled } from '@mui/system';
import styles from '../../styles/Slider.module.scss';
import stylesMuiFormLabel from '../../styles/SelectionCard.module.css';

interface SliderItemProps {
  componentKey: number;
  item: SliderItem;
  onItemChange: (item: SliderItem) => void;
  radioOptionChange: (
    event: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => void;
}

const LabelFormControl = styled(FormControlLabel)(({ theme }) => ({
  '.MuiFormControlLabel-label': {
    width: '100%',
    flex: 1
  }
}));

export const SliderOptionItem = (props: SliderItemProps) => {
  const item = props.item;
  const [showAssetLibrary, setShowAssetLibrary] = useState(false);
  const hasValue = item?.label || item?.image;

  const handleChange = (label: string) => {
    if (label.trim()) {
      const copy = cloneDeep(item);
      props.onItemChange({ ...copy, label });
    }
  };

  const handleAssetSelect = (assetkey: string) => {
    const copy = cloneDeep(item);
    props.onItemChange({ ...copy, image: assetkey });
  };

  return (
    <>
      <Grid className={styles.gridStretch}>
        <LabelFormControl
          style={{ width: '100%' }}
          key={item.id}
          value={item.id}
          control={<Radio disabled={!hasValue} color="primary" />}
          label={
            <Box
              className={`${styles.itemLabel} ${stylesMuiFormLabel.muiFormControlLabel} bordered-editor`}
            >
              <InlineQuillEdit
                key={item.id}
                placeholder={
                  hasValue ? 'Click to edit option' : 'Click to add an option'
                }
                value={item.label}
                componentKey={props.componentKey}
                notAllowEmptyValue
                restrictEnterKey
                styleType={'label'}
                onChange={handleChange}
              />
            </Box>
          }
          onChange={props.radioOptionChange}
        />
      </Grid>

      <Grid>
        {item.image ? (
          <img
            className={styles.sliderItemThumbnail}
            src={AssetService.getAssetUrl(item.image)}
            onClick={() => setShowAssetLibrary(true)}
          />
        ) : (
          <IconButton
            className={!hasValue ? styles.sliderBlankItem : ''}
            size="small"
            onClick={() => setShowAssetLibrary(true)}
          >
            <ImageIcon />
          </IconButton>
        )}
      </Grid>

      {showAssetLibrary && (
        <AssetLibrary
          types={['image']}
          category="author"
          title="Select Image"
          selectedAssetkey={item.image}
          onSelect={(assetkey) => handleAssetSelect(assetkey)}
          onClose={() => setShowAssetLibrary(false)}
        />
      )}
    </>
  );
};
